import * as Tgcc from '../tgccGlobal';
import * as React from 'react';
import Radium, { StyleRoot } from 'radium';
import {CSSProperties} from 'react';
import {connect} from 'react-redux';


const wrapperStyle : CSSProperties = {
    display: 'flex',
    justifyContent: 'center',
    flexDirection: 'column',
    backgroundColor: 'white',
    width: '185px',
    paddingBottom: '10px',
    fontFamily: 'CenturyGothic',
    boxShadow: Tgcc.Styles.boxShadow,
    fontSize: '8px',
    letterSpacing: '1px',
    textTransform: 'uppercase',
    margin: '5px',
     '@media (max-width:800px) and (max-height:1280px)': {
        margin:'10px auto'
    },
    '@media (max-width:768px) and (max-height:1366px)': {
        margin:'10px auto'
    },
    '@media (max-width:768px) and (max-height:1024px)': {
        margin:'10px auto'
    },
    '@media (max-width:414px)': {
        margin:'auto auto 10px auto'
    }
};

const logoStyle : CSSProperties = {
    display: 'flex',
    alignSelf: 'center',
    height: '20px',
    margin: '2px'
};
let logoTextStyle : CSSProperties = {
    alignSelf: 'center',
    height: '20px',
    lineHeight: '20px',
    margin: '5px',
    fontFamily: 'CenturyGothic',
    fontSize: '10px',
    letterSpacing: '3px',
    display: 'none'
};

const contentStyle : CSSProperties = {
    height: '170px',
    width: '165px',
    marginLeft: '10px',
    border: Tgcc.Styles.singleBorder,
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    flexDirection: 'column'
};

const styleStyle : CSSProperties = {
    height: '20px',
    fontSize: '16px',
    lineHeight: '20px',
    letterSpacing: '3px',
    maxWidth: '100%'
};

const styleNoPicStyle : CSSProperties = {
    height: '40px',
    fontSize: '24px',
    lineHeight: '40px',
    letterSpacing: '5px'
};

const imageStyle : CSSProperties = {
    maxWidth: '80%',
    maxHeight: '75%',
    cursor: 'pointer'
};

const descStyle: CSSProperties = {
    textAlign:'center'
}


class CardProps{
    product: Tgcc.Product;
    brand: Tgcc.ProductBrand;
    onSelect?: (product : Tgcc.Product) => void;
}

class _ProductCard extends React.Component<CardProps,any> {

    handleSelection = (evt) => {
        if (this.props.onSelect){ 
            this.props.onSelect(this.props.product);
        }
    }

    handleImageError = (event: React.SyntheticEvent<HTMLImageElement>) => {
        event.currentTarget.src = Tgcc.Styles.missingProductImageSrc;
    }

    handleMissingLogo =  (event: React.SyntheticEvent<HTMLImageElement>) => {
        event.currentTarget.style.display='none';
        var sibling: any = event.currentTarget.nextSibling
        var style = sibling.attributes['style'].value.replace('display: none;','display: flex;');
        sibling.attributes['style'].value=style;
    }
    
    render() {
        let cardHeader = null;
        let cardImage = this.props.product.thumbnail;
        let cardStyle = this.props.product.style;
        let description = this.props.product.description;

        return (
            <div style={wrapperStyle}>
                <img style={logoStyle} src={this.props.brand.thumbnail} title={this.props.brand.brand} onError={this.handleMissingLogo} />
                <div style={logoTextStyle}>{this.props.brand.brand}</div>
                <div style={contentStyle} onClick={this.handleSelection}>
                    <img style={imageStyle} src={cardImage.replace(' ', '%20')} onError={this.handleImageError} />
                    <div style={styleStyle}>{cardStyle}</div>
                    <div style={descStyle}>{description}</div>
                </div>
            </div>
        )
    }
}
export var ProductCard = Radium(_ProductCard);

